import { createContext, useContext } from 'react'

import CRMItemUIStore from '../stores/CRMItemUIStore/CRMItemUIStore'

export const CRMItemUIStoreContext = createContext<CRMItemUIStore | null>(null)

const useCRMItemUIStore = (): CRMItemUIStore => {
   const crmItemUIStore = useContext(CRMItemUIStoreContext)

   if (!crmItemUIStore) {
      throw new Error('Expected to be wrapped in CRMItemUIStore Provider')
   }

   return crmItemUIStore
}

export { useCRMItemUIStore }
